'use strict';

import Component from 'generic.basecomponent';
import app from 'app-instance';

export default class PinSwitcher extends Component {
    constructor(el) {
        super(el);
        this.switcherItemSelector = '.js-google-pin-switcher-item';
        this.init();
    }

    init() {
        this.mapId = this.container.getAttribute('data-map-id');
        let items = [...this.container.querySelectorAll(this.switcherItemSelector)];
        items.forEach((item, index) => {
            item.addEventListener('click', () => {
                app.emitEvent(`map:${this.mapId}`, [index]);
            })
        })
    }
}



// WEBPACK FOOTER //
// ./app/components/map/js/generic.pin-switcher.js